import { Component, OnInit, ViewChild, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';

// import { SuppInvPaymentMethodComponent } from '../supp-inv-payment-method/supp-inv-payment-method.component';
import { TranslateService } from '@ngx-translate/core';
import { OrderTypeComponent } from '../order-type/order-type.component';
import { KeyboardComponent } from '../keyboard/keyboard.component';
import { OrderCommentComponent } from '../order-comment/order-comment.component';
import { ChooseTableComponent } from '../choose-table/choose-table.component';
import { SuppInvPaymentMethodComponent } from '../supp-inv-payment-method/supp-inv-payment-method.component';
import { CashPaymentComponent } from '../cash-payment/cash-payment.component';
import { StoreSelectComponent } from '../store-select/store-select.component';

@Component({
  selector: 'app-sale-point',
  templateUrl: './sale-point.component.html',
  styleUrls: ['./sale-point.component.css']
})
export class SalePointComponent implements OnInit {

  public menu_item_id = '16';
  public add_auth;

  model = {
    'table_name': 'qutation', 'qutation_id': '0', 'qutation_no': '', 'no': '0', 'year': '', 
    'qutation_date': '0000-00-00', 'expiry_date': '0000-00-00', 'customer_no': '', 'customer_name': '', 
    'calc_tax': '1', 'print_tax': '1', 'total': '', 'tax': '', 'discount': '', 'cond_list_id': '0', 
    'invoice_type': 'pos', 'service_method': '', 'serv_table_id': '', 'flag': '', 'key': 'qutation_id', 
    'status': '2', 'branch_id': this.applicationConstants.user_branch_info.user_branch_id, 'store_id': '0'
  };

  data_model = {
    'qutationDate': new Date(), 'expiryDate': new Date(), 'final_total': '', 'service_method_name': '',
    'service_method_name_en': '', 'table_number': '', 'bank_acct_number': '', 'is_cc': '0', 
    'paid_amount': '', 'rem_amount': ''
  };

  inv_model = {
    'table_name': 'invoice', 'invoice_id': '0', 'invoice_no': '', 'invoice_date': '0000-00-00', 'customer_no': '',
    'customer_name': '', 'calc_tax': '1', 'print_tax': '1', 'total': '', 'tax': '', 'discount': '', 'rep_emp_no': '0',
    'deliver_date': '0000-00-00', 'payment_date': '0000-00-00', 'invoice_type': 'pos', 'cond_list_id': '0',
    'transport_fee': '0', 'received_by': '', 'is_paid': '1', 'status': '1', 'cost_center': '0',
    'sales_acct': '0', 'acct_number': '0', 'flag': '', 'key': 'invoice_id', 'service_method': '',
    'serv_table_id': '', 'qutation_no': '', 'tax_acct': '0', 'trans_acct': '0', 'payment_method': '', 'comment': '',
    'meter_reading': '', 'worker': '', 'branch_id': this.applicationConstants.user_branch_info.user_branch_id,
    'store_id': '0', 'no': '0', 'year': ''
  };

  // data_model = { 'invoiceDate': new Date(), 'final_total': '', 'bank_acct_number': '0', 'service_method_name': '', 
  //   'customer_name': '' };

  item_model = {
    'avail_amount': '', 'unit_no': '', 'count': '', 'price': '', 'discount': '', 'net_price': '', 'location': '',
    'serial': '', 'sub_item_no': '', 'sub_item_number': '', 'tax_no': '', 'total_price': '', 'tax_amount': '',
    'min_sale_qty': '', 'comment': '', 'id': '', 'stock_link': '0', 'flavour_list': []
  };

  serviceMethodList = [{ 'value': 'dine_in', 'service_method_name': 'محلي', 'service_method_name_en': 'Dine in' },
  { 'value': 'take_away', 'service_method_name': 'سفري', 'service_method_name_en': 'Take Away' },
  { 'value': 'delivery', 'service_method_name': 'توصيل', 'service_method_name_en': 'Delivery' },
  { 'value': 'car_order', 'service_method_name': 'سيارة', 'service_method_name_en': 'Car Order' }];


  search_obj = {
    'placeholder': 'اسم العميل/ رقم العميل/ رقم الجوال', 'class_name': 'fieldTd',
    'table_list': [{
      'table_name': '`customer`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'customer_name', 'customer_name_en', 'mobile'],
      'condition': " AND `branch_id` = '" + this.model['branch_id'] + "'"
    }]
  };

  // search_obj = {
  //   'placeholder': 'اسم العميل/ رقم العميل/ رقم الجوال', 'class_name': 'fieldTd',
  //   'table_list': [{
  //     'table_name': '`customer`', 'selected_no': 'customer_no',
  //     'field_list': ['customer_no', 'customer_name', 'customer_name_en', 'mobile', 'comment']
  //   }]
  // };

  no = '';
  public view = 1;
  col_count = 7;
  buttonStyle = ['formbutton', 'formbuttonG', 'formbuttonR', 'formbuttonY'];
  print_type; company_name_ar; company_contact; company_tax_no; print_tax;
  thermal_print_type;
  public itemSubCatList = [];
  public subItemList = [];
  selectedSubItem;
  public dp = [];
  displayedColumns = ['chx_del', 'sub_item_name', 'net_price'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  storeDialogRef: MatDialogRef<StoreSelectComponent>;

  // customerList = [];
  taxList = [];
  public flavourList = [];
  private dp1 = [];
  all_payment_types = [];
  payment_list = [];
  old_serv_table_id = '';
  public toDelete = [];
  orderTypeClicked = false;
  tableClicked = false;
  paymentClicked = false;
  saveClicked = false;

  session_no = '';
  customerDetail = '';
  store_name;
  stock_list = {};
  qty_list = {};

  One_Item_Msg;
  Customer_Msg;
  Customer_Cc_Msg;
  Success_Msg;
  Customer_Placeholder;
  Request_No;
  Inv_No_Msg;
  Error_Msg;
  Del_Line_Msg;
  No_Bank_Msg;
  Not_Counter_Msg;
  Cant_Add_Msg1;
  Cant_Add_Msg2;

  reqTypeDialogRef: MatDialogRef<OrderTypeComponent>;
  commentDialogRef: MatDialogRef<OrderCommentComponent>;
  tableDialogRef: MatDialogRef<ChooseTableComponent>;
  payDialogRef: MatDialogRef<SuppInvPaymentMethodComponent>;
  cashPaymentDialogRef: MatDialogRef<CashPaymentComponent>;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService,
    private router: Router, private route: ActivatedRoute) {
    this.getMessages(translate);
  }

  // private changeDetectorRefs: ChangeDetectorRef
  getMessages(translate) {
    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('One_Item_Msg').subscribe((res: string) => {
      this.One_Item_Msg = res;
    });

    translate.get('Customer_Msg').subscribe((res: string) => {
      this.Customer_Msg = res;
    });

    translate.get('Customer_Cc_Msg').subscribe((res: string) => {
      this.Customer_Cc_Msg = res;
    });

    translate.get('Customer_Placeholder').subscribe((res: string) => {
      this.Customer_Placeholder = res;
    });
    this.search_obj['placeholder'] = this.Customer_Placeholder;

    translate.get('Request_No').subscribe((res: string) => {
      this.Request_No = res;
    });

    translate.get('Inv_No_Msg').subscribe((res: string) => {
      this.Inv_No_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Line_Msg').subscribe((res: string) => {
      this.Del_Line_Msg = res;
    });

    translate.get('No_Bank_Msg').subscribe((res: string) => {
      this.No_Bank_Msg = res;
    });

    translate.get('Not_Counter_Msg').subscribe((res: string) => {
      this.Not_Counter_Msg = res;
    });

    translate.get('Cant_Add_Msg1').subscribe((res: string) => {
      this.Cant_Add_Msg1 = res;
    });

    translate.get('Cant_Add_Msg2').subscribe((res: string) => {
      this.Cant_Add_Msg2 = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    // translate.get('No_Customer').subscribe((res: string) => {
    //   this.No_Customer = res;
    //   this.data_mode.customer_name = this.No_Customer;
    // });
  }

  ngOnInit() {
    // check add authorization
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);

    let query, obj;

    //check if there is an open session
    query = "SELECT * FROM `pos_session` WHERE `status` = '1' AND `cashier` = '" + this.applicationConstants.user_info.casher_acct_number +
      "' AND `machine` = '" + this.applicationConstants.machine_no + "' AND `close_time` IS NULL";
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        let session = data.data['list'];
        if (session.length == 0) {
          this.router.navigate(['sub_menu/1/pos_session_open']);
        }
        else
          this.session_no = session['0']['session_no'];
      });

    // get item sub cat
    query = this.queryList.all_itemSubCat;
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        let result = data.data['list'];

        this.itemSubCatList = [];
        let row_count = Math.ceil(result.length / this.col_count);
        let col_list, start, end, counter;

        for (let count = 0; count < row_count; count++) {
          col_list = [];
          start = count * this.col_count;
          end = start + this.col_count;
          col_list = result.slice(start, (end <= result.length ? end : result.length + 1));

          counter = 0;
          col_list.forEach(element => {
            element.formbutton = this.buttonStyle[counter];
            counter++;

            if (counter == 4)
              counter = 0;
          });
          this.itemSubCatList.push({ 'row_index': count, 'col_list': col_list });
        }

      });

    this.model['calc_tax'] = this.utils.getParamValue('cal_tax');
    
    this.print_type = this.utils.getParamValue('print_type');
    let different_branch = this.utils.getParamValue('different_branch');
    if (different_branch == '1') {
      query = this.queryList.all_branch + " AND `branch_id` = '" + 
        this.applicationConstants.user_branch_info.user_branch_id + "'";

      obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
  
          if (data.data['list'].length > 0)
            this.print_type = data.data['list'][0]['print_type'];

          let condition = (this.print_type == 'normal' ? "`def_cond_list_id` = '1'" : "`def_cond_list_id` = '2'");

          query = "SELECT `cond_list_id` FROM `def_inv_cond_list` WHERE " + condition;
          obj = { cmd: 'getList', query: query };
          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();

              if (data.data['list'].length > 0)
                this.model['cond_list_id'] = data.data['list'][0]['cond_list_id'];
              this.inv_model['cond_list_id'] = this.model['cond_list_id'];
            });
        });
    }
    this.thermal_print_type = this.utils.getParamValue('thermal_print_type');
    
    this.company_name_ar = this.utils.getParamValue('company_name_ar');
    this.company_contact = this.utils.getParamValue('company_contact');
    this.company_tax_no = this.utils.getParamValue('company_tax_no');
    this.print_tax = this.utils.getParamValue('print_tax');

    let default_payment_type = this.utils.getParamValue('default_payment_type');
    if (default_payment_type != '' && default_payment_type != null && default_payment_type != undefined) {

      query = "SELECT * FROM `payment_type` WHERE `status` = '1' AND `payment_type_key` = '" +
        default_payment_type + "'";
      obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          this.payment_list = data.data['list'];
        });
    }

    // get Tax list
    query = this.queryList.all_tax_types;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.taxList = data.data['list'];

        // selObj = { 'acct_number': '0', 'tax_name_ar': 'اختر', 'tax_name_en': 'Select' };
        // this.taxList.unshift(selObj);
      });

    // ******************* Get All Payment Types to send array to supp_inv_payment_method component ******************* //
    query = this.queryList.all_paymentType;
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.all_payment_types = data.data['list'];
        if (this.all_payment_types.length == 5)
          this.all_payment_types.splice(4, 1);

      });
    
    this.route.params.subscribe(params => {
      // console.log(params);
      if (params['no'] != undefined && params['no'] != 'null') {
        this.no = params['no'];
        let query, obj;

        // get Order Detail 
        query = "SELECT * FROM `qutation` WHERE `qutation_no` = '" + this.no + "'";
        obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            let result = data.data['list'][0];

            this.model.qutation_id = result['qutation_id'];
            this.model.qutation_no = result['qutation_no'];
            this.model.no = result['no'];
            this.model.year = result['year'];
            this.model.qutation_date = result['qutation_date'];
            this.data_model.qutationDate = new Date(result['qutation_date']);
            // console.log(this.data_model.qutationDate);
            // console.log(this.data_model.qutationDate.getHours() + ':' + this.data_model.qutationDate.getMinutes());
            this.model.expiry_date = result['expiry_date'];
            this.data_model.expiryDate = new Date(result['expiry_date']);
            this.model.customer_no = result['customer_no'];
            this.model.customer_name = result['customer_name'];
            this.model.total = result['total'];
            this.model.tax = result['tax'];
            this.model.discount = result['discount'];
            this.model.service_method = result['service_method'];
            this.model.serv_table_id = result['serv_table_id'];
            this.old_serv_table_id = result['serv_table_id'];
            this.model.flag = 'update';
            this.model.status = result['status'];
            this.model['branch_id'] = result['branch_id'];
            this.model['store_id'] = result['store_id'];
            this.data_model.final_total = (Number(result['total']) - Number(result['discount']) + Number(result['tax'])).toFixed(2);
          

            if (this.model['customer_no'] == '')
              this.customerDetail = this.model['customer_name'];
            // (document.getElementById('search_value_0') as HTMLInputElement).value = this.model['customer_name'];
            else {
              query = "SELECT * FROM `customer` WHERE `customer_no` = '" + this.model['customer_no'] + "'";
              obj = { cmd: 'getList', query: query };

              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();

                  let custDetail = data.data['list'][0];
                  this.customerDetail = custDetail['customer_no'] + "-" + custDetail['customer_name'] +
                    "-" + custDetail['customer_name_en'] + "-" + custDetail['mobile'];

                  // (document.getElementById('search_value_0') as HTMLInputElement).value = custDetail['customer_no'] +
                  //   "-" + custDetail['customer_name'] + "-" + custDetail['customer_name_en'] + "-" +
                  //   custDetail['mobile'];
                });
            }

            for (let i = 0; i < this.serviceMethodList.length; i++) {
              if (this.serviceMethodList[i].value == this.model.service_method) {
                this.data_model.service_method_name = this.serviceMethodList[i].service_method_name;
                this.data_model.service_method_name_en = this.serviceMethodList[i].service_method_name_en;
                break;
              }
            }

            if (this.model['service_method'] == 'dine_in' && this.model['serv_table_id'] != '0') {
              query = "SELECT * FROM `serv_table` WHERE `serv_table_id` = '" + this.model['serv_table_id'] + "'";
              obj = { cmd: 'getList', query: query };

              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();
                  this.data_model['table_number'] = data.data['list'][0]['table_number'];
                });
            }
          });

        // get Invoice Detail if exist
        query = "SELECT * FROM `invoice` WHERE `qutation_no` = '" + this.no + "'";
        obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            if (data.data['list'].length > 0) {
              let inv_result = data.data['list'][0];

              this.inv_model.invoice_id = inv_result['invoice_id'];
              this.inv_model.no = inv_result['no'];
              this.inv_model.year = inv_result['year'];
              this.inv_model.invoice_no = inv_result['invoice_no'];
              this.inv_model.invoice_date = inv_result['invoice_date'];
              this.inv_model.flag = 'update';
              this.inv_model.qutation_no = inv_result['qutation_no'];
              this.inv_model.is_paid = inv_result['is_paid'];
              this.inv_model['branch_id'] = inv_result['branch_id'];
              this.inv_model['store_id'] = inv_result['store_id'];

              // get invoice item
              this.getQutationItem();

              // get invoice payment 
              this.getPaymentMethod();
            }
            else
              // get invoice item
              this.getQutationItem();
          });
      }
      else {
        let user_id = this.applicationConstants.user_info['user_id'];
        //get store list:
        let query = "SELECT `store`.* FROM `store`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
          " `store`.`branch_id` AND `store`.`status` = '1' AND `branch_auth`.`status` = '1' AND" +
          " `branch_auth`.`branch_id` = '" + this.applicationConstants.user_branch_info.user_branch_id +
          "' AND `branch_auth`.`user_id` = '" + user_id + "' AND `branch_auth`.`store_id` = `store`.`store_id`";

        let obj = { cmd: 'getList', query: query };
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            let store_list = [];
            store_list = data.data['list'];

            if (store_list.length > 1) {
              let dialog_data = store_list;
              this.storeDialogRef = this.dialog.open(StoreSelectComponent, {
                hasBackdrop: false,
                data: dialog_data
              });
              this.storeDialogRef
                .afterClosed()
                .subscribe(result => {
                  if (result != null && result['op_type'] == 'success') {
                    this.model['store_id'] = this.applicationConstants.user_branch_info.user_store_id;
                    this.inv_model['store_id'] = this.applicationConstants.user_branch_info.user_store_id;
                    this.store_name = (this.applicationConstants.user_lang == 'ar' ? this.applicationConstants.user_branch_info.user_store_name : this.applicationConstants.user_branch_info.user_store_name_en);
                  }
                });
            }
            else {
              this.applicationConstants.user_branch_info.user_store_id = store_list['0']['store_id'];
              this.model['store_id'] = this.applicationConstants.user_branch_info.user_store_id;
              this.inv_model['store_id'] = this.applicationConstants.user_branch_info.user_store_id;
              this.applicationConstants.user_branch_info.user_store_name = (this.applicationConstants.user_lang == 'ar' ? store_list['0']['store_name'] : store_list['0']['store_name_en']);
              this.store_name = (this.applicationConstants.user_lang == 'ar' ? this.applicationConstants.user_branch_info.user_store_name : this.applicationConstants.user_branch_info.user_store_name_en);
            }

          });
      }

      if (params['table_id'] != undefined && params['table_id'] != 'null') {

        this.model['service_method'] = this.serviceMethodList[0]['value'];
        this.model['serv_table_id'] = params['table_id'];
        this.data_model['service_method_name'] = this.serviceMethodList[0]['service_method_name'];
        this.data_model['service_method_name_en'] = this.serviceMethodList[0]['service_method_name_en'];

        query = "SELECT * FROM `serv_table` WHERE `serv_table_id` = '" + this.model['serv_table_id'] + "'";
        obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            this.data_model['table_number'] = data.data['list'][0]['table_number'];
          });
      }
    });

  }

  getQutationItem() {
    let query, obj;

    if (this.inv_model['invoice_id'] == '0') 
      obj = { cmd: 'getInvoiceItem', type: 'qutation', invoice_no: this.no };
    else 
      obj = { cmd: 'getInvoiceItem', type: 'qutation', invoice_no: this.inv_model['invoice_no'] };
    
    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        let result;
        let alertMsg = '';
        let total_qty = 0;
        if (data.status['type'] == 'success')
          result = data.status['msg'];

        result.forEach(element => {
          total_qty = 0;
          this.dp.forEach(element1 => {
            if (element.sub_item_no == element1.sub_item_no)
              total_qty += Number(element1.count);
          });
          total_qty += Number(element.count);

          if (element.stock_link == '0' || (element.stock_link == '1' && total_qty <= Number(element.available_count))) {
            element.flavour_price = '0';

            element.key = 'qutation_item_id';
            element.flavour_list = [];

            if (this.stock_list[element.sub_item_no] == undefined)
              this.stock_list[element.sub_item_no] = element.available_stock;

            this.dp.push(element);
          }
          else {
            if (alertMsg != "")
              alertMsg += " - "
            alertMsg += element.sub_item_name;
          }
        });

        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;

        if (alertMsg != "") 
          alert(this.Cant_Add_Msg1 + " (" + alertMsg + ") " + this.Cant_Add_Msg2);
      });
  }

  getPaymentMethod() {
    let query = "SELECT `inv_payment_method`.*, `payment_type`.*, 'update' AS 'flag', " +
      "'inv_payment_method_id' AS 'key' FROM `inv_payment_method`, `payment_type` WHERE " +
      "`inv_payment_method`.`invoice_no` = '" + this.inv_model['invoice_no'] + "' AND " +
      "`inv_payment_method`.`payment_type_id` = `payment_type`.`payment_type_id` AND " +
      "`inv_payment_method`.`status` != '0'";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        // this.inv_payment_method = data.data['list'];
        this.dp1 = data.data['list'];
        console.log(this.dp1);

        // let index;
        this.dp1.forEach(element => {
          if (element.payment_type_key == 'bank' || element.payment_type_key == 'visa')
            this.data_model['bank_acct_number'] = element.acct_number;

          // ******************* Based on the invoice payment method fill amount, inv_payment_method_id and falg in All Payment Types array ******************* //
          this.all_payment_types.forEach(element1 => {

            if (element1.payment_type_id == element.payment_type_id) {
              element1.amount = element.amount;
              element1.inv_payment_method_id = element.inv_payment_method_id;
            }
            else if (element1.flag == undefined) {
              element1.amount = '';
              element1.inv_payment_method_id = '';
            }
            element1.flag = '';
          });
        });
        console.log(this.all_payment_types);
      });
  }

  selectReqType(addSubItem = false) {
    this.orderTypeClicked = true;

    this.reqTypeDialogRef = this.dialog.open(OrderTypeComponent, {
      hasBackdrop: false,
      width: "300px",
      data: { 'service_method': this.model.service_method, 'serv_table_id': this.model.serv_table_id }
    });
    this.reqTypeDialogRef
      .afterClosed()
      .subscribe(result => {
        this.orderTypeClicked = false;
        if (result['service_method'] != undefined) {
          this.model['service_method'] = result['service_method'];
          for (let i = 0; i < this.serviceMethodList.length; i++) {
            if (this.serviceMethodList[i].value == this.model.service_method) {
              this.data_model.service_method_name = this.serviceMethodList[i].service_method_name;
              this.data_model.service_method_name_en = this.serviceMethodList[i].service_method_name_en;
              break;
            }
          }

          if (result['serv_table_id'] != undefined) {
            this.model.serv_table_id = result['serv_table_id'];
            this.data_model['table_number'] = result['table_number'];
            console.log(this.data_model['table_number']);
          }

          if (addSubItem)
            this.addSubItem();
        }

      });
  }

  addByBarcode() {

  }

  openRequestList() {
    this.router.navigate(['sub_menu/1/request_list']);
  }

  openNew() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['sub_menu/1/sale_point']); // navigate to same route
    });
  }

  changePaid() {
    if (this.data_model['paid_amount'] != '')
      this.data_model['rem_amount'] = (Number(this.data_model['paid_amount']) - Number(this.data_model['final_total'])).toFixed(2);
    else
      this.data_model['rem_amount'] = '';
  }

  saveOrder() {
    this.saveClicked = true;
    let not_Printed = 0;
    let invoice_item = [];
    let year, idWhere, prefix;

    if (this.model['total'] == '' || Number(this.model['total']) == 0) {
      alert(this.One_Item_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.dp1.length > 0 && this.inv_model['is_paid'] == '0' && this.model['customer_no'] == '') {
      alert(this.Customer_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.dp1.length > 0 && this.inv_model['is_paid'] == '0' && this.data_model['is_cc'] == '0') {
      alert(this.Customer_Cc_Msg);
      this.saveClicked = false;
      return;
    }

    let is_cash = false;
    this.dp1.forEach(element => {
      if (element.payment_type_key == 'cash')
        is_cash = true;
    });

    if (is_cash && this.applicationConstants.user_info['is_counter'] == '0') {
      alert(this.Not_Counter_Msg);
      this.saveClicked = false;
      return;
    }

    let values = [];
    var theDate = this.data_model['qutationDate'];//
    if (this.model['qutation_id'] == '0')
      theDate = new Date();

    this.model['qutation_date'] = (theDate.getFullYear() + "-" +
      (theDate.getMonth() + 1) + "-" + theDate.getDate() + ' ' +
      theDate.getHours() + ':' + theDate.getMinutes() + ':' + theDate.getSeconds());

    this.model['expiry_date'] = this.model['qutation_date'];
    if (this.inv_model['invoice_id'] == '0' && this.dp1.length > 0)
      this.model['status'] = '1';

    if (this.model['qutation_id'] == '0') {
      year = theDate.getFullYear();
      this.model['year'] = year;
    }

    // Qutation Header
    values.push(this.model);

    if (this.model['qutation_id'] == '0')
      not_Printed = this.dp.length;

    // Qutation Item
    this.dp.forEach(element => {

      values.push({
        'table_name': 'qutation_item', 'qutation_item_id': element.qutation_item_id,
        'qutation_no': this.model['qutation_no'], 'sub_item_number': element.sub_item_number,
        'sub_item_name': element.sub_item_name, 'count': element.count,
        'price': (Number(element.price) + Number(element.flavour_price)),
        'unit_id': element.unit_id, 'total_price': element.total_price, 'tax_no': element.tax_no,
        'tax_amount': element.tax_amount, 'flag': element.flag, 'key': 'qutation_item_id',
        'discount': element.discount, 'revenue_acct_no': element.revenue_acct_no, 'comment': element.comment
      });

      invoice_item.push({
        'main_item_id': element.main_item_id, 'sub_item_name': element.sub_item_name, 
        'unit_name': element.unit_name, 'unit_name_en': element.unit_name_en, 
        'price': (Number(element.price) + Number(element.flavour_price)).toFixed(2),
        'count': element.count, 'qutation_item_id': element.qutation_item_id,
        'total_price': (Number(element.total_price) - Number(element.discount)).toFixed(2),
        'tax_amount': element.tax_amount, 'discount': element.discount,
        'net_total_price': (Number(element.total_price) - Number(element.discount) + Number(element.tax_amount)).toFixed(2),
        'printed': (element.qutation_item_id == '0' ? '0' : '1')
      });

      if (this.model['qutation_id'] != '0' && element.qutation_item_id == '0')
        not_Printed++;

    });

    console.log(values);
    
    let obj;
    if (this.model['qutation_id'] == '0') {
      
      idWhere = " WHERE `year` = '" + year + "' AND `branch_id` = '" + 
        this.applicationConstants.user_branch_info.user_branch_id + "'";
      prefix = 'ORD-' + this.applicationConstants.user_branch_info.user_branch_id + "-" + year + "-";

      obj = {
        cmd: 'add', values: values, pk: 'qutation_no', id: 'no', main_table: 'qutation',
        prefix: prefix, idWhere: idWhere
      };
    }
    else 
      obj = { cmd: 'updateAdv', values: values };

    console.log(obj); 
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        console.log(data);
        if (data.status['type'] == 'success') {

          if (this.model['qutation_id'] == '0')
            this.model['qutation_no'] = data.status['msg'][0]['number'];


          values = [];
          // Save or Update Invoice
          if ((this.inv_model['invoice_id'] == '0' && this.dp1.length > 0) || 
            this.inv_model['invoice_id'] != '0') {

            if (this.inv_model['invoice_id'] == '0') {
              theDate = new Date();

              this.inv_model['invoice_date'] = (theDate.getFullYear() + "-" +
                (theDate.getMonth() + 1) + "-" + theDate.getDate() + ' ' +
                theDate.getHours() + ':' + theDate.getMinutes() + ':' + theDate.getSeconds());
            }
            // this.inv_model['invoice_date'] = this.model['qutation_date'];
            this.inv_model['payment_date'] = this.inv_model['invoice_date'];
            this.inv_model['deliver_date'] = this.inv_model['invoice_date'];
            this.inv_model['customer_no'] = this.model['customer_no'];
            this.inv_model['customer_name'] = this.model['customer_name'];
            this.inv_model['total'] = this.model['total'];
            this.inv_model['tax'] = this.model['tax'];
            this.inv_model['discount'] = this.model['discount'];
            this.inv_model['service_method'] = this.model['service_method'];
            this.inv_model['serv_table_id'] = this.model['serv_table_id'];

            let first_tax_acct = this.dp['0']['tax_no'];
            let first_sales_acct = this.dp['0']['revenue_acct_no'];

            let is_equal_tax = true;
            let is_equal_sales_acct = true;
            this.dp.forEach(element => {
              if (element.tax_no != first_tax_acct)
                is_equal_tax = false;

              if (element.revenue_acct_no != first_sales_acct)
                is_equal_sales_acct = false;
            });

            // TO DO HASSAN (6-17-20) changed temp because of workshop program [START]
            if (is_equal_tax)
              this.inv_model['tax_acct'] = first_tax_acct; // this.applicationConstants.sales_acct.tax_acct; //
            if (is_equal_sales_acct)
              this.inv_model['sales_acct'] = first_sales_acct; //this.applicationConstants.sales_acct.acct_number;//

            // [END]

            if (this.dp1.length == 1) {
              if (this.dp1[0].payment_type_key == 'credit')
                this.inv_model['acct_number'] = this.inv_model['customer_no'];
              else if (this.dp1[0].payment_type_key == 'cash')
                this.inv_model['acct_number'] = this.applicationConstants.user_info.casher_acct_number;
              else if (this.dp1[0].payment_type_key == 'bank' || this.dp1[0].payment_type_key == 'visa')
                this.inv_model['acct_number'] = this.data_model['bank_acct_number'];

              this.inv_model['payment_method'] = this.dp1[0].payment_type_key;
            }
            else {
              this.inv_model['acct_number'] = '0';
              this.inv_model['payment_method'] = '';
            }
            values.push(this.inv_model);

            // Invoice Item
            let available_stock, counter, count_discount, count_tax;

            this.dp.forEach(element => {

              available_stock = this.stock_list[element.sub_item_no];
              counter = Number(element.count);

              if (element.available_count >= counter && available_stock.length > 0) {

                count_discount = 0;
                count_tax = 0;
                if (Number(element.discount) > 0)
                  count_discount = Number(element.discount) / Number(element.count);
    
                if (Number(element.tax_amount) > 0)
                  count_tax = Number(element.tax_amount) / Number(element.count);

                available_stock.forEach(element1 => {

                  if (element1.available_count > 0 && counter > 0) {
    
                    if (element1.available_count >= counter) {
                      values.push({
                        'table_name': 'invoice_item', 'invoice_no': this.inv_model['invoice_no'],
                        'invoice_date': this.inv_model['invoice_date'],
                        'sub_item_number': element.sub_item_number, 'sub_item_name': element.sub_item_name, 
                        'count': counter, 'price': (Number(element.price) + Number(element.flavour_price)), 
                        'unit_id': element.unit_id,
                        'total_price': (counter * (Number(element.price) + Number(element.flavour_price))).toFixed(2), 
                        'tax_no': element.tax_no, 'invoice_item_id': element.invoice_item_id,
                        'tax_amount': (counter * count_tax).toFixed(2),
                        'flag': element.flag, 'key': 'invoice_item_id', 
                        'discount': (counter * count_discount).toFixed(2),
                        'stock_no': element1.stock_no, 'store_id': element1.store_id,
                        'primary_sub_item_number': element1.primary_sub_item_number,
                        'primary_quantity': (Number(element1.primary_qty) * counter).toFixed(2),
                        'comment': element.comment, 'revenue_acct_no': element.revenue_acct_no
                      });
    
                      element1.available_count = (Number(element1.available_count) - counter);
                      counter = 0;
                    }
                    else {
                      values.push({
                        'table_name': 'invoice_item', 'invoice_no': this.inv_model['invoice_no'],
                        'invoice_date': this.inv_model['invoice_date'], 'invoice_item_id': element.invoice_item_id,
                        'sub_item_number': element.sub_item_number,
                        'sub_item_name': element.sub_item_name, 'count': element1.available_count, 
                        'price': (Number(element.price) + Number(element.flavour_price)),
                        'unit_id': element.unit_id, 
                        'total_price': (Number(element1.available_count) * (Number(element.price) + Number(element.flavour_price))).toFixed(2),
                        'tax_no': element.tax_no, 'tax_amount': (Number(element1.available_count) * count_tax).toFixed(2),
                        'discount': (Number(element1.available_count) * count_discount).toFixed(2),
                        'stock_no': element1.stock_no, 'flag': element.flag, 'key': 'invoice_item_id',
                        'store_id': element1.store_id, 'primary_sub_item_number': element1.primary_sub_item_number,
                        'primary_quantity': (Number(element1.primary_qty) * Number(element1.available_count)).toFixed(2),
                        'comment': element.comment, 'revenue_acct_no': element.revenue_acct_no
                      });
    
                      element1.available_count = 0;
                      counter -= Number(element1.available_count);
                    }
                  }
                });
              }
              else {
                values.push({
                  'table_name': 'invoice_item', 'invoice_item_id': element.invoice_item_id,
                  'invoice_no': this.inv_model['invoice_no'], 'invoice_date': this.inv_model['invoice_date'],
                  'sub_item_number': element.sub_item_number, 'sub_item_name': element.sub_item_name,
                  'count': element.count, 'price': (Number(element.price) + Number(element.flavour_price)),
                  'unit_id': element.unit_id, 'total_price': element.total_price, 'tax_no': element.tax_no,
                  'tax_amount': element.tax_amount, 'flag': element.flag, 'key': 'invoice_item_id',
                  'discount': element.discount, 'revenue_acct_no': element.revenue_acct_no,
                  'stock_no': '0', 'store_id': this.model['store_id'], 'primary_sub_item_number': element.sub_item_number,
                  'primary_quantity': (Number(element.primary_quantity) * element.count).toFixed(2), 
                  'comment': element.comment
                });
              }
              
            });

            // Invoice Payment
            let inv_payment_method_id;
            let acct_number;
            this.all_payment_types.forEach(element1 => {
              if (element1.flag != '') {
                if (element1.payment_type_key == 'cash')
                  acct_number = this.applicationConstants.user_info.casher_acct_number;
                else if (element1.payment_type_key == 'credit')
                  acct_number = this.model['customer_no'];
                else if (element1.payment_type_key == 'bank' || element1.payment_type_key == 'visa')
                  acct_number = this.data_model['bank_acct_number'];

                inv_payment_method_id = element1.inv_payment_method_id;
                if (inv_payment_method_id == '' || inv_payment_method_id == null || inv_payment_method_id == undefined ||
                  inv_payment_method_id == 'undefined')
                  inv_payment_method_id = '0';

                if (element1.amount == '')
                  element1.amount = '0';

                values.push({
                  'table_name': 'inv_payment_method', 'invoice_no': this.inv_model['invoice_no'],
                  'inv_payment_method_id': inv_payment_method_id, 'flag': element1.flag, 'key': 'inv_payment_method_id',
                  'payment_type_id': element1.payment_type_id, 'acct_number': acct_number, 'amount': element1.amount
                });
              }
            });

            if (this.inv_model['invoice_id'] == '0' && this.dp1.length > 0) {
              this.inv_model['qutation_no'] = this.model['qutation_no'];

              year = theDate.getFullYear();
              this.inv_model['year'] = String(year);
              
              idWhere = " WHERE `year` = '" + year + "' AND `branch_id` = '" + 
                this.applicationConstants.user_branch_info.user_branch_id + "'";
              prefix = this.applicationConstants.user_branch_info.user_branch_id + '-' + year + '-';

              obj = {
                cmd: 'add', values: values, pk: 'invoice_no', id: 'no', main_table: 'invoice',
                prefix: prefix, idWhere: idWhere
              };

            }
            else if (this.inv_model['invoice_id'] != '0') {
              // empty reserved table
              if (this.old_serv_table_id != '') {
                values.push({
                  'table_name': 'serv_table', 'qutation_no': '', 'serv_table_id': this.old_serv_table_id,
                  'key': 'serv_table_id', 'flag': 'update', 'res_status': '1'
                });
              }

              this.toDelete.forEach(delElem => {
                values.push({
                  'table_name': delElem['table_name'], 'qutation_item_id': delElem.qutation_item_id,
                  'key': 'qutation_item_id', 'flag': 'delete'
                });
                if (delElem['table_name'] == 'qutation_item' && this.inv_model['invoice_id'] != '0') {
                  values.push({
                    'table_name': 'invoice_item', 'invoice_item_id': delElem.invoice_item_id,
                    'key': 'invoice_item_id', 'flag': 'delete', 'invoice_no': this.inv_model['invoice_no']
                  });
                }
              });

              obj = { cmd: 'updateAdv', values: values };
            }

            console.log(values);
            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                if (data.status['type'] == 'success') {

                  // empty reserved table
                  let where = [];
                  values = [];
                  if (this.inv_model['invoice_id'] == '0' && this.dp1.length > 0 && this.old_serv_table_id != '') {
                    values.push({ 'table_name': 'serv_table', 'qutation_no': '', 'res_status': '1' });
                    where.push({ 'serv_table_id': this.old_serv_table_id });
                  }

                  if (this.inv_model['invoice_id'] == '0')
                    this.inv_model['invoice_no'] = data.status['msg'][0]['number'];

                  if (values.length > 0) {
                    obj = { cmd: 'update', values: values, where: where };
                    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                      .subscribe(data => {
                        this.applicationConstants.appComp.hideBusyCursor();

                        if (data.status['type'] == 'success') {
                          // alert(this.Success_Msg + ', ' + this.Request_No + ': ' +  this.model['qutation_no'] + 
                          //   ', ' + this.Inv_No_Msg + ': ' + this.inv_model['invoice_no']);

                          // if (type == 'save_print') {
                          if (this.print_type == 'normal') {
                            window.open(this.applicationConstants.generateInvoice + "?no=" + this.inv_model['invoice_no'], "_blank");
                            // this.router.navigate(['sub_menu/1/request_list']);
                            // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                            //   this.router.navigate(['sub_menu/1/sale_point']); // navigate to same route
                            // });
                          }
                          else if (this.print_type == 'thermal') {

                            if (this.thermal_print_type == 'pdf')
                              window.open(this.applicationConstants.generateThermalInvoice + "?no=" + this.inv_model['invoice_no'], "_blank");
                            else {
                              this.model['service_method_name'] = this.data_model['service_method_name'];
                              this.model['service_method_name_en'] = this.data_model['service_method_name_en'];
                              this.model['table_number'] = this.data_model['table_number'];
                              this.model['not_Printed'] = not_Printed;

                              let printObj = {
                                cmd: 'printThermal', type: 'invoice', no: this.inv_model['invoice_no'],
                                params: this.applicationConstants.param, order_info: this.model,
                                invoice_item: invoice_item, created_by: this.applicationConstants.user_info['name'],
                                user_id: this.applicationConstants.user_info['user_id']
                              };
                              console.log(printObj);
                              this.utils.invokeHttp(this.applicationConstants.saleFuncFile, printObj)
                                .subscribe(data => {
                                  // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                                  //   this.router.navigate(['sub_menu/1/sale_point']); // navigate to same route
                                  // });
                                });
                            }
                          }
                          this.router.navigate(['sub_menu/1/request_list']);

                          // }
                          // else {
                          //   this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                          //     this.router.navigate(['sub_menu/1/sale_point']); // navigate to same route
                          //   });
                          // }
                        }
                        else {
                          alert(this.Error_Msg);
                          this.saveClicked = false;
                        }
                      });
                  }
                  else {
                    // alert(this.Success_Msg + ', ' + this.Request_No + ': ' + this.model['qutation_no'] + ', ' + 
                    //   this.Inv_No_Msg + ': ' + this.inv_model['invoice_no']);

                    // if (type == 'save_print') {
                    if (this.print_type == 'normal') {
                      window.open(this.applicationConstants.generateInvoice + "?no=" + this.inv_model['invoice_no'], "_blank");
                      // this.router.navigate(['sub_menu/1/request_list']);
                      // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                      //   this.router.navigate(['sub_menu/1/sale_point']); // navigate to same route
                      // });
                    }
                    else if (this.print_type == 'thermal') {

                      if (this.thermal_print_type == 'pdf')
                        window.open(this.applicationConstants.generateThermalInvoice + "?no=" + this.inv_model['invoice_no'], "_blank");
                      else {
                        this.model['service_method_name'] = this.data_model['service_method_name'];
                        this.model['service_method_name_en'] = this.data_model['service_method_name_en'];
                        this.model['table_number'] = this.data_model['table_number'];
                        this.model['not_Printed'] = not_Printed;

                        let printObj = {
                          cmd: 'printThermal', type: 'invoice', no: this.inv_model['invoice_no'],
                          params: this.applicationConstants.param, order_info: this.model,
                          invoice_item: invoice_item, created_by: this.applicationConstants.user_info['name'],
                          user_id: this.applicationConstants.user_info['user_id']
                        };
                        console.log(printObj);
                        this.utils.invokeHttp(this.applicationConstants.saleFuncFile, printObj)
                          .subscribe(data => {
                            // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                            //   this.router.navigate(['sub_menu/1/sale_point']); // navigate to same route
                            // });
                          });
                      }
                    }
                    this.router.navigate(['sub_menu/1/request_list']);
                    // }
                    // else {
                    //   this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                    //     this.router.navigate(['sub_menu/1/sale_point']); // navigate to same route
                    //   });
                    // }
                  }

                }
                else {
                  alert(this.Error_Msg);
                  this.saveClicked = false;
                }
              });
          }
          else {
            this.toDelete.forEach(delElem => {
              values.push({
                'table_name': delElem['table_name'], 'qutation_item_id': delElem.qutation_item_id,
                'key': 'qutation_item_id', 'flag': 'delete'
              });
            });

            if (values.length > 0) {
              obj = { cmd: 'updateAdv', values: values };
              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();
                });
            }

            // Save Table Number if the request typs is dine_in
            if (this.model['service_method'] == 'dine_in' && this.model['serv_table_id'] != '') {

              let where = [];

              if (this.model['qutation_id'] != '0' && this.old_serv_table_id != '') {
                values.push({ 'table_name': 'serv_table', 'qutation_no': '', 'res_status': '1' });
                where.push({ 'serv_table_id': this.old_serv_table_id });
              }
              values.push({ 'table_name': 'serv_table', 'qutation_no': this.model['qutation_no'], 'res_status': '2' });
              where.push({ 'serv_table_id': this.model['serv_table_id'] });

              obj = { cmd: 'update', values: values, where: where };
              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();

                  if (data.status['type'] == 'success') {
                    // alert(this.Success_Msg + ', ' + this.Request_No + ': ' + this.model['qutation_no']);

                    // if (type == 'save_print') {
                    if (this.print_type == 'thermal') {

                      if (this.thermal_print_type == 'pdf')
                        window.open(this.applicationConstants.generateThermalInvoice + "?type=request&no=" + this.model['qutation_no'], "_blank");
                      else {
                        this.model['service_method_name'] = this.data_model['service_method_name'];
                        this.model['service_method_name_en'] = this.data_model['service_method_name_en'];
                        this.model['table_number'] = this.data_model['table_number'];
                        this.model['not_Printed'] = not_Printed;

                        let printObj = {
                          cmd: 'printThermal', type: 'order', no: this.model['qutation_no'],
                          params: this.applicationConstants.param, order_info: this.model,
                          invoice_item: invoice_item, created_by: this.applicationConstants.user_info['name'],
                          user_id: this.applicationConstants.user_info['user_id']
                        };
                        console.log(printObj);
                        this.utils.invokeHttp(this.applicationConstants.saleFuncFile, printObj)
                          .subscribe(data => {
                            // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                            //   this.router.navigate(['sub_menu/1/sale_point']); // navigate to same route
                            // });
                          });
                      }
                    }
                    this.router.navigate(['sub_menu/1/request_list']);
                    // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                    //   this.router.navigate(['sub_menu/1/sale_point']); // navigate to same route
                    // });

                    // }
                    // else {
                    //   this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                    //     this.router.navigate(['sub_menu/1/sale_point']); // navigate to same route
                    //   });
                    // }
                  }
                  else {
                    alert(this.Error_Msg);
                    this.saveClicked = false;
                  }

                });
            }
            else {
              // alert(this.Success_Msg + ', ' + this.Request_No + ': ' + this.model['qutation_no']);

              // if (type == 'save_print') {
              if (this.print_type == 'thermal') {

                if (this.thermal_print_type == 'pdf')
                  window.open(this.applicationConstants.generateThermalInvoice + "?type=request&no=" + this.model['qutation_no'], "_blank");
                else {
                  this.model['service_method_name'] = this.data_model['service_method_name'];
                  this.model['service_method_name_en'] = this.data_model['service_method_name_en'];
                  this.model['table_number'] = this.data_model['table_number'];
                  this.model['not_Printed'] = not_Printed;

                  let printObj = {
                    cmd: 'printThermal', type: 'order', no: this.model['qutation_no'],
                    params: this.applicationConstants.param, order_info: this.model,
                    invoice_item: invoice_item, created_by: this.applicationConstants.user_info['name'],
                    user_id: this.applicationConstants.user_info['user_id']
                  };
                  console.log(printObj);
                  this.utils.invokeHttp(this.applicationConstants.saleFuncFile, printObj)
                    .subscribe(data => {
                      // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                      //   this.router.navigate(['sub_menu/1/sale_point']); // navigate to same route
                      // });
                    });
                }
              }
              alert(this.Success_Msg);
              this.router.navigate(['sub_menu/1/request_list']);
              // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              //   this.router.navigate(['sub_menu/1/sale_point']); // navigate to same route
              // });

              // }
              // else {
              //   this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              //     this.router.navigate(['sub_menu/1/sale_point']); // navigate to same route
              //   });
              // }
            }
          }
        }
        else {
          alert(this.Error_Msg);
          this.saveClicked = false;
        }
      });
    // }
  }

  addPayment() {
    if (this.model['total'] != '' && Number(this.model['total']) != 0) {
      this.paymentClicked = true;
      this.saveClicked = true;

      let dialog_data = {
        'total_amount': this.data_model['final_total'], 'payment_methods': this.dp1,
        'all_payment_types': this.all_payment_types
      };
      // if (type == null) { type = null , 'type': 'sale_point'
      //   dialog_data['type'] = 'sale_point';
      // }

      this.payDialogRef = this.dialog.open(SuppInvPaymentMethodComponent, {
        hasBackdrop: false,
        data: dialog_data
      });
      this.payDialogRef
        .afterClosed()
        .subscribe(result => {
          this.paymentClicked = false;

          if (result != null && result['op_type'] == 'success') {
            if (result['payment_methods'] != undefined && Array.isArray(result['payment_methods'])) {
              this.dp1 = result['payment_methods'];
              if (result['all_payment_types'] != undefined && Array.isArray(result['all_payment_types']))
                this.all_payment_types = result['all_payment_types'];

              let cash_existed = false;
              let credit_existed = false;
              let bank_existed = false;

              this.dp1.forEach(element => {
                if (element.payment_type_key == 'cash')
                  cash_existed = true;
                else if (element.payment_type_key == 'credit')
                credit_existed = true;
                else if (element.payment_type_key == 'bank' || element.payment_type_key == 'visa')
                  bank_existed = true;
              });
              this.inv_model['is_paid'] = (credit_existed ? '0' : '1');
              // this.model['is_paid'] = this.inv_model['is_paid'];

              // let type = '';
              // if (result['op_type'] != undefined)
              //   type = result['op_type'];

              // get first bank account
              if (bank_existed && this.data_model['bank_acct_number'] == '')
                this.getBankAccount(cash_existed);
              // else if (cash_existed) {
              //   this.cashPaymentDialogRef = this.dialog.open(CashPaymentComponent, {
              //     hasBackdrop: false,
              //     data: { 'total': this.data_model['final_total'] }
              //   });
              //   this.cashPaymentDialogRef
              //     .afterClosed()
              //     .subscribe(result => {
              //       if (result != null && result['op_type'] == 'success')
              //         this.saveOrder();
              //       else {
              //         if (this.inv_model['invoice_id'] == '0')
              //           this.dp1 = [];
              //         this.saveClicked = false;
              //       }
              //     });
              // }
              else
                this.saveOrder();

              // if (this.dp1.length > 0) 
              //   this.saveOrder(type);
              // else 
              //   this.saveClicked = false;

            }
          }
          else {
            if (this.inv_model['invoice_id'] == '0')
              this.dp1 = [];
            this.saveClicked = false;
          }

        });
    }
    else
      alert(this.One_Item_Msg);
  }

  getBankAccount(cash_existed) {
    let query = this.queryList.all_bank + " LIMIT 1";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.data['list'].length > 0) {
          this.data_model['bank_acct_number'] = data.data['list'][0]['acct_number'];

          if (cash_existed) {
            this.cashPaymentDialogRef = this.dialog.open(CashPaymentComponent, {
              hasBackdrop: false,
              data: { 'total': this.data_model['final_total'] }
            });
            this.cashPaymentDialogRef
              .afterClosed()
              .subscribe(result => {
                if (result != null && result['op_type'] == 'success')
                  this.saveOrder();
                else {
                  if (this.inv_model['invoice_id'] == '0')
                    this.dp1 = [];
                  this.saveClicked = false;
                }
              });
          }
          else
            this.saveOrder();
        }
        else {
          if (this.inv_model['invoice_id'] == '0')
            this.dp1 = [];
          alert(this.No_Bank_Msg);
        }



        // if (this.dp1.length > 0)
        //   this.saveOrder(type);
        // else 
        //   this.saveClicked = false;
      });
  }

  // cancel() {
  //   this.op
  // }

  selectSubCat(item_subcat_id) {
    // let query;
    // query = "SELECT `main_item`.`main_item_name`, `main_item`.`main_item_name_en`, `main_item`.`def_tax_acct`, " +
    //   "`main_item`.`revenue_acct_no`, `sub_item`.*, `unit`.`unit_name`, `unit`.`unit_name_en` FROM `main_item`, " +
    //   " `sub_item`, `unit` WHERE `main_item`.`item_subcat_id` = '" + item_subcat_id +
    //   "' AND `main_item`.`status` = '1' AND  `main_item`.`main_item_id` = `sub_item`.`main_item_id` AND " +
    //   "`sub_item`.`status` = '1' AND `sub_item`.`unit_id` = `unit`.`unit_id`";

    // obj = { cmd: 'getList', query: query };

    let obj = { cmd: 'getSubCatSubItem', store_id: this.model['store_id'], 
      item_subcat_id: item_subcat_id };

    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        let result = data.data['list'];

        this.subItemList = [];
        let row_count = Math.ceil(result.length / this.col_count);
        let col_list, start, end, counter;

        for (let count = 0; count < row_count; count++) {
          col_list = [];
          start = count * this.col_count;
          end = start + this.col_count;
          col_list = result.slice(start, (end <= result.length ? end : result.length + 1));

          counter = 0;
          col_list.forEach(element => {
            element.formbutton = this.buttonStyle[counter];
            counter++;

            if (counter == 4)
              counter = 0;
          });
          this.subItemList.push({ 'row_index': count, 'col_list': col_list });
        }
        this.view = 2;
      });
  }

  selectSubItem(sub_item) {
    this.selectedSubItem = sub_item;
    console.log(this.selectedSubItem);
    if (this.model.service_method == '') {
      // show service method pop up
      let addSubItem = true;
      this.selectReqType(addSubItem);
    }
    else
      this.addSubItem();
  }

  showTables() {
    this.tableClicked = true;
    this.tableDialogRef = this.dialog.open(ChooseTableComponent, {
      hasBackdrop: false,
      data: { 'dialog_type': 'select_table', 'serv_table_id': this.model.serv_table_id }
    });
    this.tableDialogRef
      .afterClosed()
      .subscribe(result => {
        this.tableClicked = false;

        if (result['serv_table_id'] != undefined) {
          this.model.serv_table_id = result['serv_table_id'];
          this.data_model.table_number = result['table_number'];
        }

      });
  }

  goBack() {
    this.view = (this.view - 1); 
  }

  addSubItem() {
   
    this.item_model.count = (this.selectedSubItem.min_sale_qty == 1 ? this.selectedSubItem.min_sale_qty : '1');
    let item_qty;

    if (this.qty_list[this.selectedSubItem.sub_item_no] == undefined) 
      item_qty = this.item_model.count;
    else 
      item_qty = Number(this.qty_list[this.selectedSubItem.sub_item_no]) + Number(this.item_model.count);

    if (this.selectedSubItem.stock_link == '1' && item_qty > Number(this.selectedSubItem.available_count)) 
      alert(this.Cant_Add_Msg1 + this.selectedSubItem.sub_item_no + this.Cant_Add_Msg2);
    else {
      this.qty_list[this.selectedSubItem.sub_item_no] = item_qty;
      if (this.stock_list[this.selectedSubItem.sub_item_no] == undefined)
        this.stock_list[this.selectedSubItem.sub_item_no] = this.selectedSubItem.available_stock;
    
      this.view = 3;
      let next_id = 1;
      if (this.dp.length > 0)
        next_id = Number(this.dp[this.dp.length - 1]['id']) + 1;

      this.selectedSubItem.id = next_id;
      this.selectedSubItem.qutation_item_id = '0';
      this.selectedSubItem.invoice_item_id = '0';
      this.selectedSubItem.flag = 'new';
      
      this.selectedSubItem.count = this.item_model.count;
      this.selectedSubItem.sub_item_name = this.selectedSubItem.count + ' X' +
        (this.applicationConstants.user_lang == 'ar' ? this.selectedSubItem.main_item_name : this.selectedSubItem.main_item_name_en);
      this.item_model.price = this.selectedSubItem.price;
      this.item_model.discount = "0";
      this.selectedSubItem.discount = this.item_model.discount;
      this.selectedSubItem.tax_no = this.selectedSubItem.def_tax_acct;
      console.log(this.selectedSubItem.tax_no);
      this.selectedSubItem.flavour_price = 0;
      this.selectedSubItem.total_flavour_price = 0;
      this.selectedSubItem.flavour_list = [];
      this.selectedSubItem.comment = '';

      this.dp.push(this.selectedSubItem);
      this.dataSource = new MatTableDataSource(this.dp);
      this.dataSource.sort = this.sort;

      this.calculateTotal(this.selectedSubItem.id);
      this.getFlavourList();
    }
  }

  getFlavourList() {
    let query, obj;
    query = this.queryList.all_flavour + " AND `main_item_id` = '" + this.selectedSubItem.main_item_id + "'";
    obj = { cmd: 'getList', query: query };
    console.log(query);

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        let result = data.data['list'];

        this.flavourList = [];
        let row_count = Math.ceil(result.length / 5);
        let col_list, start, end;

        for (let count = 0; count < row_count; count++) {
          col_list = [];
          start = count * 5;
          end = start + 5;
          col_list = result.slice(start, (end <= result.length ? end : result.length + 1));
          this.flavourList.push({ 'row_index': count, 'col_list': col_list });
        }
      });
  }

  count(type) {
    if (type == 'add')
      this.item_model['count'] = String(Number(this.item_model['count']) + 1);
    else if (type == 'subtract' && Number(this.item_model['count']) > this.selectedSubItem.min_sale_qty)
      this.item_model['count'] = String(Number(this.item_model['count']) - 1);

    this.selectedSubItem.count = this.item_model.count;
    this.changeItemName();
    this.calculateTotal(this.selectedSubItem.id);
  }

  changeInput() {
    let count, price, discount;
    count = Number(this.item_model['count']);
    price = Number(this.item_model['price']);
    discount = Number(this.item_model['discount']);

    if (isNaN(count))
      this.item_model['count'] = String(parseFloat(count));

    if (isNaN(price))
      this.item_model['price'] = String(parseFloat(price));

    if (isNaN(discount))
      this.item_model['discount'] = String(parseFloat(discount));

    // check count 
    let total_qty = 0;
    this.dp.forEach(element => {
      if (element.sub_item_no == this.selectedSubItem.sub_item_no && element.id != this.selectedSubItem.id) 
        total_qty += Number(element.count);
    });

    total_qty += count;
    console.log('item_qty: ' + total_qty);

    if (this.selectedSubItem.stock_link == '1' && total_qty > Number(this.selectedSubItem.available_count)) {
      alert(this.Cant_Add_Msg1 + this.selectedSubItem.sub_item_no + this.Cant_Add_Msg2);
      this.selectedSubItem.count = Number(this.selectedSubItem.available_count) - (total_qty - count);
      this.qty_list[this.selectedSubItem.sub_item_no] = Number(this.selectedSubItem.available_count);
      this.item_model['count'] = this.selectedSubItem.count;
    }
    else {
      this.qty_list[this.selectedSubItem.sub_item_no] = total_qty;
      this.selectedSubItem.count = this.item_model.count;
    }
    this.selectedSubItem.price = this.item_model.price;
    this.selectedSubItem.discount = this.item_model.discount;

    this.changeItemName();
    this.calculateTotal(this.selectedSubItem.id);
  }

  changeItemName() {
    this.selectedSubItem.sub_item_name = this.selectedSubItem.count + ' X' +
      (this.applicationConstants.user_lang == 'ar' ? this.selectedSubItem.main_item_name : this.selectedSubItem.main_item_name_en);

    for (let index = 0; index < this.selectedSubItem.flavour_list.length; index++) {
      let element = this.selectedSubItem.flavour_list[index];
      if (index == 0)
        this.selectedSubItem.sub_item_name += ' (';

      this.selectedSubItem.sub_item_name += (this.applicationConstants.user_lang == 'ar' ? element.flavour_name : element.flavour_name_en);

      if (index + 1 == this.selectedSubItem.flavour_list.length)
        this.selectedSubItem.sub_item_name += ')';
      else
        this.selectedSubItem.sub_item_name += '-';
    }

    if (this.selectedSubItem.comment != '')
      this.selectedSubItem.sub_item_name += '-' + this.selectedSubItem.comment;
  }

  calculateTotal(id = '') {
    let total_price, net_price, flavour_price, total_flavour_price, tax_amount = 0, total = 0, tax = 0, discount = 0;

    this.dp.forEach(element => {
      total_price = Number(element.price) * Number(element.count);

      flavour_price = 0;
      total_flavour_price = 0;
      element.flavour_list.forEach(flavElement => {
        flavour_price += Number(flavElement.flavour_price);
        total_flavour_price += (Number(flavElement.flavour_price) * Number(element.count));
      });
      total_price += total_flavour_price;
      net_price = total_price - Number(element.discount);
      total += total_price;
      discount += Number(element.discount);
      tax_amount = 0;

      if (this.model['calc_tax'] == '1' && element.tax_no != '' && element.tax_no != '0') {

        for (let indx = 0; indx < this.taxList.length; indx++) {
          let taxElement = this.taxList[indx];

          if (taxElement.acct_number == element.tax_no) {
            // console.log(taxElement.tax_perc);
            if (taxElement.tax_perc != 0) {
              element.tax_perc = taxElement.tax_perc;
              tax_amount = (net_price * (element.tax_perc / 100));
            }
            else if (taxElement.tax_amount != 0) {
              element.tax_amnt = taxElement.tax_amount;
              tax_amount = element.tax_amnt;
            }

          }
        }
      }
     
      net_price += tax_amount;
      tax += tax_amount;

      if (id != '' && Number(id) == Number(element.id)) {
        element.total_price = total_price.toFixed(2);
        element.flavour_price = flavour_price.toFixed(2);
        element.total_flavour_price = total_flavour_price.toFixed(2);
        element.net_price = net_price.toFixed(2);
        element.tax_amount = tax_amount.toFixed(2);
      }
    });

    this.model['total'] = total.toFixed(2);
    this.model['tax'] = tax.toFixed(2);
    this.model['discount'] = discount.toFixed(2);
    this.data_model['item_discount'] = this.model['discount'];
    this.data_model['final_total'] = (total - discount + tax).toFixed(2);

    if (this.model['total'] != '' && Number(this.model['total']) != 0 && this.dp1.length > 0) {
      if (this.dp1.length == 1) {

        for (let index = 0; index < this.all_payment_types.length; index++) {
          if (this.all_payment_types[index]['payment_type_id'] == this.dp1[0]['payment_type_id']) {
            this.all_payment_types[index]['amount'] = this.data_model['final_total'];
            this.dp1[0]['amount'] = this.data_model['final_total'];
            if (this.all_payment_types[index]['inv_payment_method_id'] != '')
              this.all_payment_types[index]['flag'] = 'update';
            break;
          }
        }
      }
      else {
        let indx = 0;

        this.dp1.forEach(element => {
          if (indx == 0)
            element.amount = this.data_model['final_total'];
          else
            element.amount = '';

          this.all_payment_types.forEach(element1 => {
            if (element1.payment_type_id == element.payment_type_id) {

              if (indx == 0) {
                element1.amount = this.data_model['final_total'];
                if (element1.inv_payment_method_id != '')
                  element1.flag = 'update';
              }
              else {
                element1.amount = '';
                if (element1.inv_payment_method_id != '')
                  element1.flag = 'delete';
              }
            }
          });
          indx++;
        });

      }
    }

  }

  addComment() {
    this.commentDialogRef = this.dialog.open(OrderCommentComponent, {
      hasBackdrop: false,
      // width: "300px",
      data: { 'comment': this.selectedSubItem.comment }
    });
    this.commentDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result['comment'] != undefined) {
          this.item_model.comment = result['comment'];
          this.selectedSubItem.comment = result['comment'];
          this.changeItemName();
        }
      });
  }

  selectFlavour(flavour) {
    this.selectedSubItem.flavour_list.push(flavour);
    
    this.changeItemName();
    this.calculateTotal(this.selectedSubItem.id);
  }

  onChangeSearch = function (search_result: object) {
    this.model['customer_name'] = search_result['value'];
    this.model['customer_no'] = search_result['no'];

    if (search_result['no'] != "") {
      let query = "SELECT * FROM `customer` WHERE `acct_number` = '" + search_result['no'] + "'";
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          let customer = data.data['list'];

          if (customer.length > 0)
            this.data_model['is_cc'] = customer['0']['is_account'];
        });
    }
    else
      this.data_model['is_cc'] = '0';
  }

  delLine() {
    let count = 0;
    let row_id;

    for (let index = (this.dp.length - 1); index >= 0; index--) {
      row_id = this.dp[index]['id'];
      if ((document.getElementById('chx_del_' + row_id) as HTMLInputElement).checked) {

        if (this.dp[index]['qutation_item_id'] != '') {
          this.dp[index]['flag'] = 'delete';
          this.dp[index]['table_name'] = 'qutation_item';
          this.toDelete.push(this.dp[index]);
        }
        this.qty_list[this.dp[index]['sub_item_no']] -= Number(this.dp[index]['count']);
        this.dp.splice(index, 1);
        count++;
      }
    }

    if (count == 0)
      alert(this.Del_Line_Msg);
    else {
      this.view = 1;
      this.dataSource.data = this.dp;
      this.dataSource = new MatTableDataSource(this.dp);
      this.dataSource.sort = this.sort;
      // this.changeDetectorRefs.detectChanges();
      this.calculateTotal();
    }
  }

  highlightRow(sub_item) {
    this.view = 3;
    this.selectedSubItem = sub_item;
    this.item_model.count = sub_item.count;
    this.item_model.price = sub_item.price;
    this.item_model.discount = sub_item.discount;
    console.log(sub_item.id);

    let row_index = this.getDPIndex(sub_item.id) + 1;
    console.log(row_index);

    let table = (document.getElementById('sub_item_table') as HTMLSourceElement);
    let table_row;
    // console.log('childElementCount: ' + table.childElementCount);
    for (let index = 1; index < table.childElementCount; index++) {
      table_row = table.children[index];
      table_row.style.background = (index == row_index ? "yellow" : (index % 2 == 0 ? "transparent" : "#ececec"));
    }

    this.getFlavourList();
  }

  getDPIndex(row_id) {
    let index = 0
    for (index = 0; index < this.dp.length; index++) {
      let element = this.dp[index];
      if (element.id == row_id)
        break;
    }
    return index;
  }

}
